import React, { PureComponent } from 'react';

import FileFilters from './FileFilters';

class FilesView extends PureComponent {
  render() {
    let {
      files,
      filtersFormState,
      page,
      nextPage,
      previousPage,
      download,
    } = this.props;

    return (
      <div className="admin-files-view">
        <FileFilters {...this.props}/>
        <table>
          <thead>
          <tr>
            <th>name</th>
            <th>mimetype</th>
            <th>actions</th>
          </tr>
          </thead>
          <tbody>
            {files.map((file, i)=>{
              const name = file.name || file.filename;
              return (
                <tr className={i%2 ? 'even' : 'odd'} key={file._id}>
                  <td>{name}</td>
                  <td>{file.mimetype}</td>
                  <td>
                    <div className="action-buttons">
                      {/*<button onClick={refreshTrade} title="refresh"><i className="fi-refresh size-18"></i> refresh</button>*/}
                      <button onClick={()=>download(file)}><i className="fi-download size-18"></i> download</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tbody>
          <tr>
            <td colSpan="9">
              <ul className="pagination">
                <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                  {page > 1  ? (
                    <a onClick={e=>{
                      e.preventDefault();
                      previousPage();
                    }}>Previous</a>
                  ) : 'Previous'}

                </li>
                <li>{page}</li>
                <li className="pagination-next">
                  <a onClick={e=>{
                    e.preventDefault();
                    nextPage();
                  }}>Next</a>
                </li>
              </ul>
            </td>
          </tr>

          </tbody>
        </table>

      </div>
    );
  }
}

export default FilesView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/Files.view.js